import { render, staticRenderFns } from "./chisiamo.vue?vue&type=template&id=2c9c3e08"
import script from "./chisiamo.vue?vue&type=script&lang=js"
export * from "./chisiamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports